var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEnhanceAiBlue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83331 5.6L5.33331 7L6.73331 4.5L5.33331 2L7.83331 3.4L10.3333 2L8.93331 4.5L10.3333 7L7.83331 5.6ZM19.8333 15.4L22.3333 14L20.9333 16.5L22.3333 19L19.8333 17.6L17.3333 19L18.7333 16.5L17.3333 14L19.8333 15.4ZM22.3333 2L20.9333 4.5L22.3333 7L19.8333 5.6L17.3333 7L18.7333 4.5L17.3333 2L19.8333 3.4L22.3333 2ZM13.6733 12.78L16.1133 10.34L13.9933 8.22L11.5533 10.66L13.6733 12.78ZM14.7033 7.29L17.0433 9.63C17.4333 10 17.4333 10.65 17.0433 11.04L5.37331 22.71C4.98331 23.1 4.33331 23.1 3.96331 22.71L1.62331 20.37C1.23331 20 1.23331 19.35 1.62331 18.96L13.2933 7.29C13.6833 6.9 14.3333 6.9 14.7033 7.29Z",
    fill: "#5D5CF5"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnhanceAiBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enhanceAI-blue.d6646f75.svg";
export { ForwardRef as ReactComponent };